module.exports = __webpack_public_path__ + "img/DataEase-white.5517dfeb.png";